import Base from 'app/views/base';
import RateListItemView from 'app/views/rate_list_item_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize() {
    this.listenTo(this.collection, 'reset', this.render);
  },

  beforeRender() {
    this.removeSubviews();
    this.collection.each(rate => {
      this.addSubview(
        `rate_${rate.id}`,
        `#rate_${rate.id}`,
        new RateListItemView({ model: rate }),
      );
    });
  },

  context() {
    return {
      rates: this.collection.models,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/shipping_calculator/rate_list/index.js